var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSangriaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.101 37C133.372 37 136.752 42.6053 134.292 47.267L133.71 48.37L130.73 54.017C129.518 56.3131 127.135 57.75 124.539 57.75H51.6492C48.8676 57.75 46.3499 56.103 45.2355 53.5544L40.662 43.0946C40.6607 43.0916 40.66 43.0883 40.66 43.085V43.085C40.66 43.0817 40.6593 43.0784 40.658 43.0754L40.3399 42.3483C39.2363 39.8258 41.0844 37 43.8378 37H128.101Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5293 99.8303V99.8203",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 109.85V109.88",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7896 66.25C45.9496 75.31 43.4796 86.86 42.5396 99.82C42.4096 101.52 42.3496 103.23 42.3496 104.96C42.3496 123.3 49.4196 139.64 60.4296 150.18",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.08 150.18C130.07 140.64 136.06 125.17 137.12 109.88V109.86C137.24 108.24 137.3 106.61 137.3 104.96C137.3 88.99 133.33 76.68 124.66 66.25",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.66 66.2501C126.69 61.6901 129.19 57.3101 133.71 48.3701",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6602 43.0901V43.0801",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7901 66.25C50.3601 62.69 48.3801 59.62 47.0801 57.75",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.08 150.18V152.36C121.08 156.226 117.946 159.36 114.08 159.36H67.4199C63.5539 159.36 60.4199 156.226 60.4199 152.36V150.18",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.119 99.2701C137.119 99.2701 115.219 89.5201 91.3593 99.5401C67.4993 109.56 42.5293 99.8301 42.5293 99.8301",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.759 54.1396H147.275C150.44 54.1396 153.211 56.2632 154.034 59.3192L161.744 87.9433C162.705 91.5117 160.017 95.0196 156.321 95.0196V95.0196C153.806 95.0196 151.598 93.348 150.916 90.9277L147.191 77.7177C146.344 74.7115 143.607 72.6306 140.483 72.6174L129.189 72.5696",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.428 131.68C109.268 144.84 94.4183 151.33 81.2583 146.17C68.0983 141.01 61.6183 126.16 66.7683 113L90.5983 122.34L114.428 131.68Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7383 137.17L90.5983 122.34L94.3983 147.65",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSangriaIcon);
export default __webpack_public_path__ + "static/media/sangria-icon.02c2e3392bc83471b203643adfe47752.svg";
export { ForwardRef as ReactComponent };